import axios from "axios";
import { keyAccessToken, keyUserId } from "../../../../../assets/js/SessionStorageNames";

export const sendACampaign = (enterpriseId, pricelistId, plusPercent, dateFrom, dateTo, nameCampaign, idPage, excelFile = null, pricelistName = '') => {
    const headers = {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": localStorage.getItem(keyAccessToken),
        "x-user-id": localStorage.getItem(keyUserId),
    };

    if (excelFile) {
        const formData = new FormData();
        formData.append('xlsx', excelFile);
        formData.append('pricelistId', pricelistId);
        formData.append('plusPercent', plusPercent);
        formData.append('enterpriseId', enterpriseId);
        formData.append('pricelistName', pricelistName);
        formData.append('dateFrom', dateFrom);
        formData.append('dateTo', dateTo);
        formData.append('nameCampaign', nameCampaign);
        if (idPage) formData.append('idPage', idPage);

        return axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/woo-campaign/send-from-excel-pricelist`, formData, {
            headers,
        });
    }

    const res = axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/woo-campaign/send-from-odoo-pricelist`,
        {
            pricelistId,
            plusPercent,
            enterpriseId,
            dateFrom,
            dateTo,
            nameCampaign,
            idPage
        }, {
        headers: {
            ...headers,
        },
    })
    return res;
}